import { useAccount } from "$src/stores/use-account";
import { Config } from "$src/stores/use-config";
import { Auth } from "@aws-amplify/auth";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

export const amplifyConfig = (appConfig: Config) => ({
  aws_project_region: "ap-southeast-2",
  aws_cognito_identity_pool_id: appConfig?.AWS_COGNITO_IDENTITY_POOL_ID,
  aws_cognito_region: "ap-southeast-2",
  aws_user_pools_id: appConfig?.AWS_USER_POOLS_ID,
  aws_user_pools_web_client_id: appConfig?.AWS_USER_POOLS_WEB_CLIENT_ID,
  oauth: {
    domain: appConfig?.AWS_COGNITO_OAUTH_DOMAIN,
    scope: [
      "phone",
      "email",
      "openid",
      "profile",
      "aws.cognito.signin.user.admin",
    ],
    redirectSignIn: "http://localhost:8000/",
    redirectSignOut: "http://localhost:8000/",
    responseType: "code",
  },
  federationTarget: "COGNITO_USER_POOLS",
  aws_cloud_logic_custom: [
    {
      name: "tracksuitAPI",
      endpoint: appConfig?.BACKEND_API_URL,
      region: "ap-southeast-2",
    },
  ],
});

export const useLogout = () => {
  const clearAccount = useAccount((s) => s.reset);
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return async function logout() {
    clearAccount();
    localStorage.clear();
    await Auth.signOut();
    queryClient.removeQueries();
    navigate("/login");
  };
};
